import { Box, Fab } from "@mui/material";
import React from "react";
import { useTaskContext } from "./context";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";

export const TaskTopBanner = ({ taskOperationsParam, buttonType }) => {
  const { setCurrentOperationPage } = useTaskContext();
  return (
    <>
      <Box component="section" flex={1} textAlign={"right"}>
        {buttonType === "back" ? (
          <Fab
            color="primary"
            size="small"
            aria-label="Back"
            onClick={() => setCurrentOperationPage(taskOperationsParam)}
          >
            <ArrowBackIcon />
          </Fab>
        ) : (
          <Fab
            color="primary"
            size="small"
            aria-label="Add"
            onClick={() => setCurrentOperationPage(taskOperationsParam)}
          >
            <AddIcon />
          </Fab>
        )}
      </Box>
      <ToolbarThinWrapper />
    </>
  );
};
